import { toDatoLocale } from 'modules/marketplace/components/utils/locales'
import { countryCode } from 'modules/marketplace_modules/components/utils/countryCode'

export { toDatoLocale }

export const toDatoCountryCode = (country: string): string => {
  return countryCode(country.trim().toLowerCase())
}
